import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Natural-key i18n: English strings are the keys; missing keys fall back to English.
const es = {
  // Sidebar sections
  'Overview': 'Resumen',
  'Acquire': 'Adquirir',
  'Create & Publish': 'Crear y Publicar',
  'Convert & Nurture': 'Convertir y Nutrir',
  'Operate': 'Operar',
  'Partner': 'Socio',
  // Sidebar items
  'Home': 'Inicio',
  'Dashboard': 'Panel',
  'Business Health': 'Salud del Negocio',
  'Campaigns': 'Campañas',
  'Demand Map': 'Mapa de Demanda',
  'High-Intent Buyers': 'Compradores de Alta Intención',
  'Pixels': 'Píxeles',
  'Creative Insights': 'Análisis Creativo',
  'Competitors': 'Competidores',
  'Social Media': 'Redes Sociales',
  'Creative Studio': 'Estudio Creativo',
  'Creative Library': 'Biblioteca Creativa',
  'SEO Blog Engine': 'Motor de Blog SEO',
  'Flyers': 'Volantes',
  'Proposals': 'Propuestas',
  'GEO Engine': 'Motor GEO',
  'Funnels': 'Embudos',
  'Landing Pages': 'Páginas de Aterrizaje',
  'Chat Widgets': 'Widgets de Chat',
  'Leads': 'Prospectos',
  'AI Agents': 'Agentes IA',
  'LinkedIn': 'LinkedIn',
  'Messenger & Nurture': 'Messenger y Nutrición',
  'Nurture Campaigns': 'Campañas de Nutrición',
  'AI Reply Drafter': 'Redactor de Respuestas IA',
  'Outreach (CSV)': 'Alcance (CSV)',
  'Email Triage': 'Clasificación de Correos',
  'Scheduling': 'Agenda',
  'Sales Coach': 'Coach de Ventas',
  'Team': 'Equipo',
  'Weekly Digest': 'Resumen Semanal',
  'Settings': 'Configuración',
  'Partner Dashboard': 'Panel de Socio',
  'Marketing Library': 'Biblioteca de Marketing',
  'Sign out': 'Cerrar sesión',
  // Settings page
  'Manage your account and integrations': 'Administra tu cuenta e integraciones',
  'Profile': 'Perfil',
  'Integrations': 'Integraciones',
  'Notifications': 'Notificaciones',
  'Billing': 'Facturación',
  'Brand Kit': 'Kit de Marca',
  'Save Changes': 'Guardar Cambios',
  'Saving...': 'Guardando...',
  'Full Name': 'Nombre Completo',
  'Email': 'Correo Electrónico',
  'Language': 'Idioma',
  'Choose the language for menus and buttons across Veluro. AI-generated content will also reply in your language.': 'Elige el idioma de los menús y botones en Veluro. El contenido generado por IA también responderá en tu idioma.',
  'English': 'English',
  'Spanish': 'Español',
  'Language updated': 'Idioma actualizado',
  'Current Plan': 'Plan Actual',
  'AI Sales Coach Seats': 'Asientos del Coach de Ventas IA',
  // Common
  'Save': 'Guardar',
  'Cancel': 'Cancelar',
  'Delete': 'Eliminar',
  'Loading...': 'Cargando...',
  'Settings saved': 'Configuración guardada',
  'Failed to save': 'Error al guardar',
  // Dashboard
  'Your AI-powered acquisition system at a glance': 'Tu sistema de adquisición impulsado por IA de un vistazo',
  'Live': 'En Vivo',
  'Analytics': 'Analítica',
  'Command Center': 'Centro de Mando',
  'Reports': 'Informes',
  'AI Copilot': 'Copiloto IA',
  'Get your personalized daily briefing and action items': 'Recibe tu resumen diario personalizado y acciones a tomar',
  "Get Today's Briefing": 'Ver el Resumen de Hoy',
  'Analyzing your business data...': 'Analizando los datos de tu negocio...',
  'Leads Over Time': 'Prospectos en el Tiempo',
  'Campaign Performance': 'Rendimiento de Campañas',
  'Conversion Rate': 'Tasa de Conversión',
  '+2.4% from last week': '+2.4% desde la semana pasada',
  'Total Ad Spend': 'Inversión Publicitaria Total',
  'Across all campaigns': 'En todas las campañas',
  'Return on ad spend': 'Retorno de la inversión publicitaria',
  'Your AI ICP Brief': 'Tu Informe ICP de IA',
  'Ready': 'Listo',
  'Highest-intent target segments, channels, and a 30-day playbook — derived from your business profile.': 'Segmentos objetivo de mayor intención, canales y un plan de 30 días — derivados del perfil de tu negocio.',
  'Building...': 'Generando...',
  'View Brief': 'Ver Informe',
  'Generate ICP Brief': 'Generar Informe ICP',
  'What would you like me to do next?': '¿Qué te gustaría que haga ahora?',
  'e.g. Create a social post, optimize my Meta Ads budget...': 'p. ej. Crea una publicación social, optimiza mi presupuesto de Meta Ads...',
  'Ask Veluro': 'Pregunta a Veluro',
  'Analyzing your business and finding high-intent buyers...': 'Analizando tu negocio y encontrando compradores de alta intención...',
  'No brief yet.': 'Aún no hay informe.',
  'Regenerating...': 'Regenerando...',
  'Regenerate brief': 'Regenerar informe',
  'Leads Today': 'Prospectos Hoy',
  'Meetings Booked': 'Reuniones Agendadas',
  'Sales': 'Ventas',
  'Cost Per Lead': 'Costo por Prospecto',
  'Revenue': 'Ingresos',
  'Breakdown': 'Desglose',
  'Ad Spend vs Revenue': 'Inversión Publicitaria vs Ingresos',
  'Where your money goes — and what it returns': 'A dónde va tu dinero — y qué te devuelve',
  'Leads & Meetings': 'Prospectos y Reuniones',
  'Pipeline volume over time': 'Volumen del pipeline en el tiempo',
  'Lower is better': 'Más bajo es mejor',
  'ROAS & Conversion Rate': 'ROAS y Tasa de Conversión',
  'Efficiency of your spend': 'Eficiencia de tu inversión',
  'Daily revenue contribution': 'Contribución diaria de ingresos',
  'Cost / Lead': 'Costo / Prospecto',
  'Conv. Rate': 'Tasa de Conv.',
  'AI Insights & Recommendations': 'Análisis y Recomendaciones de IA',
  'Reading your dashboard and writing recommendations…': 'Leyendo tu panel y escribiendo recomendaciones…',
  'Highest-leverage move right now': 'La acción de mayor impacto ahora mismo',
  "Today's Priority Actions": 'Acciones Prioritarias de Hoy',
  'Quick Win': 'Victoria Rápida',
  'Weekly Insight': 'Análisis Semanal',
  'Cross-module performance at a glance': 'Rendimiento de todos los módulos de un vistazo',
  'Module Breakdown': 'Desglose por Módulo',
  'Lead Sources': 'Fuentes de Prospectos',
  'Channel Performance': 'Rendimiento por Canal',
  'LinkedIn Pipeline': 'Pipeline de LinkedIn',
  'No lead data yet': 'Aún no hay datos de prospectos',
  'Business Health Score': 'Puntuación de Salud del Negocio',
  'Failed to load analytics': 'Error al cargar la analítica',
  'Last 30 days · from your connected GA4 property': 'Últimos 30 días · desde tu propiedad GA4 conectada',
  'Weekly Reports': 'Informes Semanales',
  'AI-powered business performance analysis & PDF exports': 'Análisis del rendimiento del negocio con IA y exportación a PDF',
  'Past Reports': 'Informes Anteriores',
  'No reports yet. Generate your first weekly report!': '¡Aún no hay informes. Genera tu primer informe semanal!',
  'Executive Summary': 'Resumen Ejecutivo',
  'Highlights': 'Destacados',
  'Recommendations': 'Recomendaciones',
  'Risks': 'Riesgos',
  'Next Week Priorities': 'Prioridades de la Próxima Semana',
  'Generate Report': 'Generar Informe',
  'Generating...': 'Generando...',
  // Campaigns
  'Build & launch ad campaigns, and manage AI ad drafts from High-Intent Buyers': 'Crea y lanza campañas publicitarias, y gestiona borradores de anuncios de IA de Compradores de Alta Intención',
  'Ad Campaigns': 'Campañas Publicitarias',
  'AI Ad Drafts': 'Borradores de Anuncios IA',
  'Broad Audience': 'Audiencia Amplia',
  'No AI ad drafts yet.': 'Aún no hay borradores de anuncios de IA.',
  'Generate them from': 'Genéralos desde',
  'Review, edit & queue ads': 'Revisa, edita y pon en cola los anuncios',
  // Leads
  'Filter, group & nurture your pipeline like a CRM': 'Filtra, agrupa y nutre tu pipeline como un CRM',
  'Add Lead': 'Agregar Prospecto',
  'Adding...': 'Agregando...',
  'Search leads...': 'Buscar prospectos...',
  'AI Lead Coach': 'Coach de Prospectos IA',
  'All campaigns': 'Todas las campañas',
  'All scores': 'Todas las puntuaciones',
  'All statuses': 'Todos los estados',
  'Hot (70+)': 'Caliente (70+)',
  'Warm (40-69)': 'Tibio (40-69)',
  'Cold (<40)': 'Frío (<40)',
  'Newest first': 'Más recientes primero',
  'Group by campaign': 'Agrupar por campaña',
  'Clear': 'Limpiar',
  'Name': 'Nombre',
  'Company': 'Empresa',
  'Score': 'Puntuación',
  'Status': 'Estado',
  'Source': 'Fuente',
  'Campaign': 'Campaña',
  'Coach': 'Coach',
  'Summary': 'Resumen',
  'Buying Signals': 'Señales de Compra',
  'Next Best Action': 'Siguiente Mejor Acción',
  'Conversation Recap': 'Resumen de la Conversación',
  'If you get them on a call': 'Si logras una llamada con ellos',
  'Watch for objections': 'Atento a las objeciones',
  'Interested In': 'Interesado En',
  'No briefing yet.': 'Aún no hay resumen.',
  'Reviewing history & building briefing...': 'Revisando el historial y creando el resumen...',
  'Let Veluro plan my ads': 'Que Veluro planifique mis anuncios',
  'New Campaign': 'Nueva Campaña',
  'Total Campaigns': 'Campañas Totales',
  'Total Spend': 'Inversión Total',
  'Conversions': 'Conversiones',
  'Performance': 'Rendimiento',
  'Statuses': 'Estados',
  'Scoring...': 'Puntuando...',
  'AI Score All': 'Puntuar Todo con IA',
  'Hottest first': 'Más calientes primero',
  'No leads yet. Add your first lead or run an AI agent.': 'Aún no hay prospectos. Agrega tu primer prospecto o ejecuta un agente de IA.',
  'No leads match your filters.': 'Ningún prospecto coincide con tus filtros.',
  // Social Media
  'Create, schedule, and manage your social content': 'Crea, programa y gestiona tu contenido social',
  'Create Social Post': 'Crear Publicación Social',
  'Content': 'Contenido',
  'From Library': 'Desde la Biblioteca',
  'Generate a Full Week of Content': 'Genera una Semana Completa de Contenido',
  'Image (optional)': 'Imagen (opcional)',
  'Video (optional — Sora 2)': 'Video (opcional — Sora 2)',
  'No posts yet. Create your first one!': '¡Aún no hay publicaciones. Crea la primera!',
  'Platforms': 'Plataformas',
  'Schedule Date': 'Fecha de Programación',
  'Time': 'Hora',
  'Tone': 'Tono',
  'Topic / What to post about': 'Tema / Sobre qué publicar',
  'Write your post or let AI generate it...': 'Escribe tu publicación o deja que la IA la genere...',
  'e.g. New product launch, behind-the-scenes, industry tips...': 'p. ej. Lanzamiento de producto, detrás de cámaras, consejos del sector...',
  'Describe the image you want...': 'Describe la imagen que quieres...',
  'Describe the video you want to create...': 'Describe el video que quieres crear...',
  // Funnels
  'AI-powered multi-page sales funnels': 'Embudos de venta multipágina impulsados por IA',
  'Funnel Builder': 'Constructor de Embudos',
  'Funnel Name *': 'Nombre del Embudo *',
  'Target Audience': 'Audiencia Objetivo',
  'Your Offer': 'Tu Oferta',
  'CTA Text': 'Texto del CTA',
  'No funnels yet': 'Aún no hay embudos',
  'Create your first funnel to get started': 'Crea tu primer embudo para comenzar',
  'No pages yet': 'Aún no hay páginas',
  'Select a funnel to view pages': 'Selecciona un embudo para ver sus páginas',
  'Published': 'Publicado',
  'Back': 'Atrás',
  'Duplicate': 'Duplicar',
  'Veluro is crafting your funnel pages...': 'Veluro está creando las páginas de tu embudo...',
  'e.g. Q2 Lead Gen Funnel': 'p. ej. Embudo de Prospectos Q2',
  'e.g. Small business owners with $1M+ revenue': 'p. ej. Dueños de pequeñas empresas con ingresos de $1M+',
  'e.g. Book My Free Call': 'p. ej. Reserva Mi Llamada Gratis',
  'e.g. Free 30-min strategy call': 'p. ej. Llamada estratégica gratuita de 30 min',
  // High-Intent Buyers
  'Track unlimited high-intent buying categories — only the leads you track count against your monthly plan. Veluro auto-builds your campaigns and outreach copy from them.': 'Rastrea categorías de compra de alta intención ilimitadas — solo los prospectos que rastreas cuentan para tu plan mensual. Veluro crea automáticamente tus campañas y textos de alcance a partir de ellos.',
  'Track Intent': 'Rastrear Intención',
  'My Trackers': 'Mis Rastreadores',
  'Complete your business profile for relevant ads': 'Completa el perfil de tu negocio para anuncios relevantes',
  'Welcome — your reserved audience is waiting': 'Bienvenido — tu audiencia reservada te espera',
  'Activate this tracker': 'Activar este rastreador',
  'Advanced search (no topics)': 'Búsqueda avanzada (sin temas)',
  'All audiences': 'Todas las audiencias',
  'Audience name': 'Nombre de la audiencia',
  'B2B intent (topic required)': 'Intención B2B (tema requerido)',
  'B2C intent (topic required)': 'Intención B2C (tema requerido)',
  'Cities': 'Ciudades',
  'Company URL contains': 'La URL de la empresa contiene',
  'Company name contains': 'El nombre de la empresa contiene',
  'Company · B2B': 'Empresa · B2B',
  'Describe your ideal customer': 'Describe a tu cliente ideal',
  'Edit lead group': 'Editar grupo de prospectos',
  'Filters:': 'Filtros:',
  'Has children': 'Tiene hijos',
  'High-intent leads this month': 'Prospectos de alta intención este mes',
  'Home owner': 'Propietario de vivienda',
  'How many leads to use for this list': 'Cuántos prospectos usar para esta lista',
  'Job title contains': 'El cargo contiene',
  'Leads used by this group': 'Prospectos usados por este grupo',
  'No matching cities': 'No hay ciudades coincidentes',
  'No trackers yet. Set one up in the Track Intent tab.': 'Aún no hay rastreadores. Configura uno en la pestaña Rastrear Intención.',
  'Person · B2B': 'Persona · B2B',
  'Person · B2C demographics': 'Persona · demografía B2C',
  'Pick an audience to view its high-intent records.': 'Elige una audiencia para ver sus registros de alta intención.',
  'Select all': 'Seleccionar todo',
  'Signal recency (days back, max 14)': 'Recencia de la señal (días atrás, máx. 14)',
  'Topics:': 'Temas:',
  'Type your ICP in plain English — Veluro builds the filters for you': 'Describe tu ICP en lenguaje natural — Veluro crea los filtros por ti',
  'ZIP codes': 'Códigos postales',
  'Yes (homeowner)': 'Sí (propietario)',
  'No (renter)': 'No (inquilino)',
  'Refresh': 'Actualizar',
  'No FB ad drafts yet. Run "FB Custom Audience + 3 Ads" to generate them.': 'Aún no hay borradores de anuncios de FB. Ejecuta "FB Custom Audience + 3 Ads" para generarlos.',
  'Search a city, e.g. Florence': 'Busca una ciudad, p. ej. Florencia',
  'Enter a 5-digit ZIP': 'Ingresa un código postal de 5 dígitos',
  'e.g. VP Marketing, CFO': 'p. ej. VP de Marketing, CFO',
  'e.g. acme, salesforce': 'p. ej. acme, salesforce',
  'e.g. shopify.com, .edu': 'p. ej. shopify.com, .edu',
};

i18n.use(initReactI18next).init({
  resources: { es: { translation: es } },
  lng: localStorage.getItem('veluro_lang') || 'en',
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  parseMissingKeyHandler: (key) => key,
});

export const setAppLanguage = (lang) => {
  localStorage.setItem('veluro_lang', lang);
  i18n.changeLanguage(lang);
};

export default i18n;
